import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { DocumentReportOutline, rem, SmileyFaceOutline, Text, UserGroupOutline, VStack } from '@bonusly/design-system';

import { Panel } from '../../../components/panel';
import { DirectReport } from '../../../types/user';
import { DirectReportMenu } from './direct-report-menu';
import { IconAndTextContent } from './icon-and-text-content';
import { UserNavLink } from './user-nav-link';

interface TeamPanelProps {
	directReports: DirectReport[];
	isOpen: boolean;
	isSidebarExpanded: boolean;
	onClose: () => void;
}

export const TeamPanel: FC<TeamPanelProps> = ({ directReports, isOpen, isSidebarExpanded, onClose }) => {
	const { t } = useTranslation('navigation');

	return (
		<Panel
			isOpen={isOpen}
			onClose={onClose}
			isSidebarExpanded={isSidebarExpanded}
			title={t('teamMenu.title')}
			closeButtonLabel={t('teamMenu.closePanel')}
			width={rem(350)}
			data-testid="team-panel"
		>
			<VStack id="team-menu-items" spacing={1}>
				{/* YOUR TEAM */}
				<UserNavLink to="/team/your-team" data-testid="nav-link-your-team">
					<IconAndTextContent icon={<UserGroupOutline size="md" />} label={t('teamMenu.teamHub')} isExpanded />
				</UserNavLink>

				{/* PULSE RESULTS */}
				<UserNavLink to="/team/pulse-results" data-testid="nav-link-pulse-results">
					<IconAndTextContent icon={<SmileyFaceOutline size="md" />} label={t('teamMenu.pulseResults')} isExpanded />
				</UserNavLink>

				{/* TEAM REPORT */}
				<UserNavLink to="/team/team-report" data-testid="nav-link-team-report">
					<IconAndTextContent icon={<DocumentReportOutline size="md" />} label={t('teamMenu.teamReport')} isExpanded />
				</UserNavLink>
			</VStack>

			{/* DIRECT REPORTS */}
			{directReports.length > 0 && (
				<>
					<Text fontSize={100} fontWeight="medium" color="text.softest" textAlign="left" w="100%" px={2} mt={4} mb={2}>
						{t('teamMenu.directReportsNavLabel')}
					</Text>
					<VStack as="nav" aria-label={t('teamMenu.directReportsNavLabel')} gap={rem(4)} w="100%">
						{directReports.map((directReport) => (
							<DirectReportMenu key={directReport.id} directReport={directReport} />
						))}
					</VStack>
				</>
			)}
		</Panel>
	);
};
